var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reply_24dp_5F6368_FILL0_wght400_GRAD0_opsz24 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.5 19V15C19.5 14.1667 19.2083 13.4583 18.625 12.875C18.0417 12.2917 17.3333 12 16.5 12H7.325L10.925 15.6L9.5 17L3.5 11L9.5 5L10.925 6.4L7.325 10H16.5C17.8833 10 19.0625 10.4875 20.0375 11.4625C21.0125 12.4375 21.5 13.6167 21.5 15V19H19.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack1);
export default __webpack_public_path__ + "static/media/back_1.07e29b8f22872bb7a99cdcd5beffb88a.svg";
export { ForwardRef as ReactComponent };